<template>
    <div>
        <PotentiallyInterestedSentOffer :saleOfferId="saleOfferId" :orderId="orderId" :actionsAvailable="true" ref="sentOffers" />
        <PotentiallyInterestedCompanies
            v-if="potentiallyInterestedVisible"
            :saleOfferId="saleOfferId"
            :wmFinancingSaleOfferId="this.wmFinancingSaleOfferId"
            :orderId="orderId"
            :showSearch=true
            class="mt-5"
            v-on:sent="refreshSent"
        />
        <PotentiallyInterestedManual
            v-if="callCenterOnly"
            class="mt-3"
            :sale-offer-id="saleOfferId"
        />
        <div
            v-if="callCenterOnly"
            class="mt-4"
        >
            <v-btn @click="send" color="primary" block>
              Wyślij ofertę
            </v-btn>
        </div>
    </div>
</template>

<script>
    import PotentiallyInterestedSentOffer from './PotentiallyInterestedCompanies/PotentiallyInterestedSentOffer'
    import PotentiallyInterestedCompanies from './PotentiallyInterestedCompanies/PotentiallyInterestedCompanies';
    import PotentiallyInterestedManual from './PotentiallyInterestedCompanies/PotentiallyInterestedManual';
    import permissions from "@/mixins/permissions";

    export default {
        components: {
          PotentiallyInterestedSentOffer,
          PotentiallyInterestedCompanies,
          PotentiallyInterestedManual,
        },
        mixins: [
            permissions,
        ],
        props: ['saleOfferId', 'orderId', 'potentiallyInterestedVisible', 'wmFinancingSaleOfferId'],
        methods: {
            refreshSent() {
                this.$refs.sentOffers.load();
            },
            async send() {
                if (!this.isCallCenterOnly()) {
                    return;
                }

                await this.$root.$emit('sendToManuallyAddedCompanies');
            },
        },
    }
</script>

<style scoped>

</style>